import { render, staticRenderFns } from "./AuthMessage.vue?vue&type=template&id=cb243056&scoped=true&"
import script from "./AuthMessage.vue?vue&type=script&lang=js&"
export * from "./AuthMessage.vue?vue&type=script&lang=js&"
import style0 from "./AuthMessage.vue?vue&type=style&index=0&id=cb243056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb243056",
  null
  
)

export default component.exports